import { render, staticRenderFns } from "./TestToTake.vue?vue&type=template&id=9308af7a"
import script from "./TestToTake.vue?vue&type=script&lang=js"
export * from "./TestToTake.vue?vue&type=script&lang=js"
import style0 from "./TestToTake.vue?vue&type=style&index=0&id=9308af7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports